<template>
  <div v-if="otherLink && otherLink.length > 0" class="max-w-2xl mx-auto px-4">
    <BizLabel>{{ $t("links") }}</BizLabel>
    <div class="grid gap-2 lg:grid-cols-2">
      <BizLink
        v-for="(link, i) in otherLink"
        :key="`contact-${i}`"
        :title="link.title"
        :url="link.url"
        :desc="link.description"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["otherLink"]),
  },
};
</script>
